<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter-number">PROLOGUE</h2>
<h3 class="a-head"><strong><em>One Year Ago, Aboard Swedish Cruise Line Ship Cavalcade</em></strong></h3>
<p class="flush-left-opener"><big><big>T</big></big>he old man was way too drunk – he knew that. He could barely walk. Oops! Actually, he couldn’t walk at all. He fell to his knees. There was someone there, helping him. Little someones, with their little hands all over him. Leprechauns, he figured. His grammy’s little people. He always believed – at least when he had a few whiskies in him. And he knew he had more than a few in him now. Little hands pushed him down, so he was lying on the floor. OK, this wasn’t bad, he thought. At least I can’t fall! he told himself and laughed out loud. Hands in his pockets. No, the old man said, maybe out loud. That was the money he’d won! No, no! Don’t take my money! he thought, or maybe said out loud, he wasn’t sure. He needed that money. It was for his grandson! To get him out of the trouble he was in. The old man tried to sit up, and felt the stabbing pain in his chest, the ache in his left arm, the tightness in his throat, and then he didn’t feel anything. Ever again.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?21393dca